<div style="width: 150px!important" *ngIf="accountingPosition === 'green'" class="greenTheme">
    {{currentValue  | translate }}
</div>
<div style="width: 150px!important" *ngIf="accountingPosition === 'red'" class="redTheme">
    {{currentValue  | translate  }}
</div>
<div style="width: 150px!important" *ngIf="accountingPosition === 'amber'" class="amberTheme">
    {{currentValue  | translate  }}
</div>
